import { camelCase } from 'change-case'

export const keyBy = (array, key) =>
  (array || []).reduce((r, x) => ({ ...r, [key ? x[key] : x]: x }), {})

export const collectionKeyBy = (collection, key) => {
  const c = collection || {}
  return Array.isArray(c) ? keyBy(c, key) : Object.values(keyBy(c, key))
}

export const flatten = (collection) => {
  const c = collection || {}
  return Array.isArray(c) ? c.reduce((a, b) => a.concat(b), []) : Object.values(c)
}

export const pick = (object, keys) => {
  return keys.reduce((obj, key) => {
    if (object && object.hasOwnProperty(key)) {
      obj[key] = object[key]
    }

    return obj
  }, {})
}

export const isEmpty = (obj) =>
  [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length

export const groupByWithCallback = (collection, callback, valueCallback) =>
  collection.reduce(
    (carry, value, index, source, key = callback(value)) => (
      (carry[key] || (carry[key] = [])).push(
        (valueCallback && valueCallback(value)) || value
        // eslint-disable-next-line
      ),
      carry
    ),
    {}
  )

const isArray = function (a) {
  return Array.isArray(a)
}

const isObject = function (o) {
  return o === Object(o) && !isArray(o) && typeof o !== 'function'
}

export const keysToCamel = function (o) {
  if (isObject(o)) {
    const n = {}

    Object.keys(o).forEach((k) => {
      n[camelCase(k)] = keysToCamel(o[k])
    })

    return n
  } else if (isArray(o)) {
    return o.map((i) => {
      return keysToCamel(i)
    })
  }

  return o
}
